function actionReplace(type) {
    // По ид события вставляем текст события
    switch (type) {
        case 1:
            return this.$t('Grading')
            break;
        case 2:
            return this.$t('rating_changed')
            break;
        case 3:
            return this.$t('Issuing_a_pass_with_a_reason')
            break;
        case 4:
            return this.$t('Changed_passes')
            break;
        case 5:
            return this.$t('Entering_the_lesson_topic')
            break;
        case 6:
            return this.$t('editing_the_lesson_topic')
            break;
        case 7:
            return this.$t('close_open_ej')
            break;
        case 8:
            return this.$t('close_open_ej')
            break;
        case 10:
            return this.$t('Issuing_a_pass_with_a_reason')
            break;
        case 11:
            return this.$t('Issuing_a_pass_with_a_reason')
            break;
        case 12:
            return this.$t('Changed_passes')
            break;
        case 13:
            return this.$t('Changed_passes')
            break;
        case 14:
            return this.$t('termination_of_classes')
            break;
        case 15:
            return this.$t('lesson_date_entered')
            break;
        default:
            return '-'
    }
}
function actionReplaceColor(type) {
    // По ид события вставляем цвет события
    switch (type) {
        case 1:
            return 'primary'
            break;
        case 2:
            return 'success'
            break;
        case 3:
            return 'warning'
            break;
        default:
            return 'dark'
    }
}
const payloadParams = (payload) => {
    if(payload) {
        let reqData = "";
        Object.keys(payload).forEach(key => {
            reqData += key + "=" + payload[key] + "&"
        })
        reqData = reqData.substr(0, reqData.lastIndexOf("&"))
        return '?'+reqData
    } else return ''
}
function ejBlockingIsSplittable(ejBlockingStr){
    try{
        // просьба в бекенде указывать | между str() и другими данными во время компоновки итогового текста
        let splitted = ejBlockingStr.split("|")
        if(splitted.length > 1){
            return true
        }
    } catch(error) {
        // значение может быть null
        return false
    }
    return false
}
function ejBlockingText(ejBlockingStr){
    let isSplittable = ejBlockingIsSplittable(ejBlockingStr)
    if(isSplittable){
        let final = []
        let splitted = ejBlockingStr.split("|")
        for (const element of splitted){
            let translated = this.$t(element)
            final.push(translated)
        }
        return final.join('')
    } else {
        return this.$t(ejBlockingStr)
    }

}
export  {payloadParams, actionReplace, actionReplaceColor, ejBlockingText}
